import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logoutUsuarioAction } from "../../../redux/actions/loginActions";
import Swal from "sweetalert2";

import Logo from "../Logo"

//import './style.css';

const Index = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onLogout = (e) => {
    e.preventDefault();
    // preguntar al usuario
    Swal.fire({
      title: "¿Está seguro que desea salir?",
      text: "",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        // pasarlo al action
        dispatch(logoutUsuarioAction());
        navigate("/");
      }
    });
  };

  return (
    <div>
      <aside className="main-sidebar sidebar-light bg-white">
        <Link to={"/panel"} className="brand-link d-none d-md-block">
          <Logo style={{ maxHeight: "40px", maxWidth: "130px", width: "auto" }} />
        </Link>
        <div className="sidebar">
          <nav className="mt-2">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              <li className="nav-item">
                <Link to={"/panel/entregas"} className="nav-link">
                  <i className="nav-icon far fa-calendar" />
                  <p>Entregas</p>
                </Link>
              </li>
              {/* <li className="nav-item">
                <Link to={"/panel/perfil"} className="nav-link">
                  <i className="nav-icon far fa-lock" />
                  <p>Perfil</p>
                </Link>
              </li> */}
              <li className="nav-item">
                <Link to={"/panel/contrasena"} className="nav-link">
                  <i className="nav-icon far fa-lock" />
                  <p>Contraseña</p>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/" onClick={onLogout} className="nav-link">
                  <i className="nav-icon far fa-logout" />
                  <p>Salir</p>
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </aside>
    </div>
  );
};

export default Index;
